/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import autoBind from 'auto-bind';
import Papa from 'papaparse';
import PersistenceController from './persistence/PersistenceController';

export interface CurveData {
    Id: string
    Name: string
    Code: string
    Unit: string
    ConcMin: number
    ConcMax: number
    Waterbased: string
    TMin?: number
    TMax?: number
    Tref: string
    Solvent: string
    Solubility: string
    Source: string
    Version: string
    Date: string
    c00: string
    c01: string
    c02: string
    c03: string
    c10: string
    c11: string
    c12: string
    c13: string
    c20: string
    c21: string
    c22: string
    c23: string
    c30: string
    c31: string
    c32: string
    c33: string
    Confidential: boolean
    parameter_matrix: any
    CurveDataString: string
}

class ChemicalDataController {
    private static _instance: ChemicalDataController;

    constructor() {
        autoBind(this);
    }

    public static get instance() {
        return this._instance || (this._instance = new this());
    }

    public curveData = [];

    async getAllChemicalCurves(curvesType: string = 'all_curves') {
        let savedData;
        if (curvesType === 'polaris') {
            savedData = PersistenceController.retrieveSession('polarispr53');
        } else {
            savedData = PersistenceController.retrieveSession('allChemicalCurves');
        }
        // if (savedData.length > 0) {
        //     return savedData;
        // } else {
        const data = await this.parseAllChemicalCurvesJson(savedData, curvesType)
        return data;
        // }
    }

    async parseAllChemicalCurvesJson(savedData: any, curvesType: string) {
        let results: Array<CurveData> = [];
        Papa.parse(await this.fetchCSV(curvesType), {
            // dynamicTyping: true,
            header: true,
            transform: (value: string, field: string) => {
                if (field === "Confidential") {
                    if (value === "0") return false
                    if (value === "1") return true
                }
                if (field === "Min" || field === "Max") {
                    return parseFloat(value.replace(',', '.'))
                }
                return value;
            },
            complete: (result: any) => {
                results = result.data
                if (results.length === savedData.length) {
                    results = savedData;
                    return results
                }
                results = this.createParameterMatrix(results)
                if (curvesType === 'polaris') {
                    PersistenceController.storeSession('polarispr53', results);
                } else {
                    PersistenceController.storeSession('allChemicalCurves', results);
                }
                PersistenceController.store('recent', []);
            }
        });
        return results;
    }

    createParameterMatrix(data: any) {
        const regex = /\w\d\d/;
        data.forEach((curve: any, i: any) => {
            const newMatrix: any = [
                [],
                [],
                [],
                []
            ];
            Object.keys(curve).forEach((val: any, j: number) => {
                if (regex.test(val)) {
                    const numberArray = curve[val as keyof typeof curve].toString().replace(',', '.').split('.')
                    const addDecimals = numberArray[1] ? numberArray[1].padEnd(6, '0') : '000000'
                    newMatrix[val.charAt(1)][val.charAt(2)] = ({label: val, value: numberArray[0] + '.' + addDecimals})
                }
            })
            data[i]["parameter_matrix"] = newMatrix;
        })
        return data
    }

    async fetchCSV(curvesType: string) {
        let res;
        if (curvesType === 'polaris') {
            res = await fetch('data/Polaris_chemicalcurves.csv')
        } else {
            res = await fetch('data/all_chemical_curves.csv')
        }
        const reader = res.body?.getReader()
        const result = await reader?.read()
        const decoder = new TextDecoder('utf-8')
        const csv = await decoder.decode(result?.value)
        return csv
    }
}

export default ChemicalDataController.instance;
